<template lang="pug">
.v-field-select.field-select.field-select--sort(:class="{'field-select--open': isOpened}")
	v-loader(:loading="loading" v-if="loading")
	button.field-select__sort-btn(type="button" @click="toggle" :id="uniqueId" :disabled="field.disabled")
		v-svg-icon.field-select__sort-icon(icon="sort")
	.field-select__overlay(v-if="isSm" @click="close")
	.field-select__list-wrap
		//-button.modal-window__close(v-if="isSm" type="button" aria-label="Закрыть" @click="close")
		//-	.modal-window__close-text Закрыть
		//-	v-svg-icon.modal-window__close-icon(icon="close")
		.field-select__list.scrollbar(@click="close")
			.field-select__mob-label(v-if="isSm && field.label") {{field.label}}
			.field-select__list-container
				template(v-for="(option, optionIndex) in field.options" :key="optionIndex")
					button.field-select__list-item(type="button"
							:disabled="field.disabled"
							@click="localValue = [option.value]; handleInput();")
						v-svg-icon.field-select__marker(:class="{'field-select__marker--visible': option.value === localValue[0]}"
								icon="select")
						.field-select__list-item-text {{option.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			loading: false,
			options: null,
			localValue: [],
			isOpened: false,
			uniqueId: uniqueId('field-select_'),
			selectValue: null
		};
	},

	computed: {
		activeOption() {
			if (this.options && this.options.length && this.localValue && this.localValue.length) {
				if (this.field.searchable || this.field.searchAjax) {
					return this.options.filter(option => this.localValue.includes(option.value));
				} else {
					return (this.options.filter(option => this.localValue[0] === option.value))[0].text;
				}
			}
			return null;
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		lockScrolling() {
			controller.lockScrolling(document.querySelectorAll('.field-select__list'));
		},

		unlockScrolling() {
			controller.unlockScrolling(document.querySelectorAll('.field-select__list'));
		},

		toggle() {
			if (this.isOpened) {
				this.close();
			} else {
				this.open();
			}
		},

		open() {
			if (this.isSm) {
				this.lockScrolling();
			}
			this.isOpened = true;
		},

		close() {
			this.isOpened = false;
			if (this.isSm) {
				this.unlockScrolling();
			}
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
			if (Array.isArray(this.localValue)) {
				this.selectValue = this.localValue[0];
			}
			if (!Array.isArray(this.localValue) && this.localValue) {
				this.localValue = [this.localValue];
			} else if (!Array.isArray(this.localValue) && !this.localValue) {
				this.localValue = [];
			}
			this.options = this.field && this.field.options && this.field.options.length ? this.field.options : null;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.close();
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.close();
			}
		}
	}
};
</script>
